// @ts-nocheck

import SmileOutlined from '@ant-design/icons/SmileOutlined';
import CrownOutlined from '@ant-design/icons/CrownOutlined'

export default {
  SmileOutlined,
CrownOutlined
}
    